import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Container, Row, Col, Spinner, Input, Button } from 'reactstrap'
import Breadcrumbs from '../../../../components/Common/Breadcrumb'
import { getIndividuals } from '../../../../store/ducks/admin'
import { getLegalEntities, getDraftContract } from '../../../../store/ducks/comercial'
import { notifyError, notifySuccess } from '../../../../utils/notify'
import moment from 'moment'
import powerAppsApi from '../../../../services/powerapps'
import oikosApi from '../../../../services/oikos'
import qs from 'qs'

class DraftContract extends Component {
  constructor(props) {
    super(props)
    this.state = {
      handleSubmitisLoading: false
    }

  }

  componentDidMount() {
    const { id } = this.props.match.params
    const { getIndividuals, getLegalEntities, getDraftContract } = this.props

    getIndividuals()
    getLegalEntities()
    getDraftContract(id)
  }

  handleSubmit = async action => {
    const formData = new FormData()
    let res

    try {
      this.setState({ handleSubmitisLoading: true })
      const { id } = this.props.match.params
      const { decisao, comentario } = this.state
      const aux_approval = await oikosApi.get(`/?${qs.stringify({
        table: 'ap',
        action: 'get',
        data: {
          item_id: id,
          item_tabela: 'minuta',
          ap_ativo: 1,
          ap_aprovador: this.props.auth.user.mail,
        },
      })}`)

      console.log('approval', aux_approval)
      formData.append('acao', 'aprovar')
      formData.append('fluxo', aux_approval.data[0].ap_id)
      formData.append('decisao', decisao)
      formData.append('comentario', comentario)

      res = await powerAppsApi.post('/', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Accept: 'multipart/form-data',
        },
      })
      console.log(res)

      notifySuccess('Registro efetuado.')
      this.setState({
        handleSubmitisLoading: false,
      })
      this.componentDidMount()
    } catch (err) {
      console.log(err)
      notifyError('Erro ao encontrar approval.', err.toString())
      this.setState({ handleSubmitisLoading: false,
      })
    }
  }


  render() {
    const {
      draftContract, getDraftContractIsLoading, getDraftContractError,
      legalEntities, getLegalEntitiesIsLoading, getLegalEntitiesError,
    } = this.props.comercial

    const {
      individuals, getIndividualsIsLoading, getIndividualsError,
    } = this.props.admin

    const { decisao, comentario } = this.props.admin

    if (getDraftContractIsLoading || getLegalEntitiesIsLoading || getIndividualsIsLoading) {
      return (
        <div className="centered">
          <Spinner />
        </div>
      )
    }

    if (getDraftContractError || getLegalEntitiesError || getIndividualsError) {
      return (
        <div className="centered">
          <p>{getDraftContractError || getLegalEntitiesError || getIndividualsError}</p>
        </div>
      )
    }

    if (draftContract && legalEntities && individuals) {
      const draftContractData = {
        ...draftContract,
        minuta_contratante: legalEntities.find(i => i.pj_id === draftContract.minuta_contratante),
        minuta_contratada: legalEntities.find(i => i.pj_id === draftContract.minuta_contratada),
        minuta_contratadaAssina: individuals.find(i => i.pf_id === draftContract.minuta_contratadaAssina),
      }

      console.tron.log('draftContractData', draftContractData)

      return (
        <div className="page-content">
          <Container fluid>
            <Breadcrumbs
              title="Minuta de Contrato"
              breadcrumbItems={[]}
            />

            <Row>
              <Col>
                Contratante: {draftContractData?.minuta_contratante?.pj_nomefanta}
              </Col>
            </Row>

            <Row>
              <Col>
                Contratada: {draftContractData?.minuta_contratada?.pj_nomefanta}
              </Col>
            </Row>

            <Row>
              <Col>
                Quem assina pela contratada: {draftContractData?.minuta_contratadaAssina?.pf_nomeExibicao}
              </Col>
            </Row>

            <Row>
              <Col>
                Link do arquivo:
                {' '}
                <a
                  href={`https://oikos.ecoss.is/oikos/${draftContractData?.file?.arquivo_caminho}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  {draftContractData?.file?.arquivo_desc}
                </a>
              </Col>
            </Row>

            <Row>
              <Col>
                Decisão:
                <input
                  type="radio"
                  name="decisao"
                  value="1"
                  onChange={decisao => this.setState({ decisao: decisao.target.value || null })}
                />Aprovar &nbsp;&nbsp;
						    <input
                  type="radio"
                  name="decisao"
                  value="2"
                  onChange={decisao => this.setState({ decisao: decisao.target.value || null })}
                />Rejeitar
              </Col>
            </Row>

            <Row>
              <Col>
                Comentários:
                <Input
                  type="textarea"
                  name="comentario"
                  rows={3}
                  value={comentario}
                  onChange={comentario => this.setState({ comentario: comentario.target.value || null })}
                />
              </Col>
            </Row>

            <Row>
              <Col>
                <Button
                  type="button"
                  color="primary"
                  className="mt-3 waves-effect waves-light"
                  onClick={() => this.handleSubmit()}
                >Enviar
                </Button>
              </Col>
            </Row>

          </Container>
        </div>
      )
    }

    return null
  }
}

const mapStateToProps = state => ({
  comercial: state.comercial,
  admin: state.admin,
  auth: state.auth,
})
const mapDispatchToProps = dispatch => bindActionCreators({
  getDraftContract,
  getLegalEntities,
  getIndividuals,
}, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(DraftContract)
